module.exports = __webpack_public_path__ + "img/vanuatu.e48f52c8.svg";